import { gql } from '@apollo/client';

export const DASHBOARD_ATTENDANCE = gql`
  query DashboardAttendance($input: FilterArgs) {
    attendanceRateInApprovedSessions(input: $input) {
      month
      rate
    }
  }
`;
